<template>
  <div class="p-6">
    <div class="text-2xl font-bold capitalize dark:text-white">
      {{ $t("Your Shared") }} {{ current_component }}
    </div>
    <div class="p-6 mt-6 bg-white rounded-lg shadow-lg dark:bg-dark-box-background">
      <ShareSpacePlansList v-if="current_component == 'plans'" />
      <Temporary v-else />
    </div>
  </div>
</template>

<script>
import ShareSpacePlansList from "./ShareSpacePlansList.vue"
import Temporary from "@/views/dashboard/settings/profile/Temporary.vue"
export default {
  components: { ShareSpacePlansList, Temporary },
  props: {},
  emits: [],

  computed: {
    current_component() {
      return this.$route.params.object_type
    }
  },
  watch: {},

  methods: {}
}
</script>
